import React, { useId, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Card from "../Card";
import PasswordInput from "../Form/PasswordInput";
import Button from "../Button";
import Modal from "../../components/Modal";

import useUserStore from "../../store/User.store";

import "./newPasswordChallengeCard.scss";

const NewPasswordChallengeCard = (props) => {
  const handleNewPasswordChallenge = useUserStore(
    (state) => state.actions.handleNewPasswordChallenge
  );
  const challengeUser = useUserStore((state) => state.data.challengeUser);

  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const methods = useForm({
    mode: "onTouched",
  });
  const loginPasswordValue = methods.watch("loginPassword");
  const loginPasswordConfirmValue = methods.watch("loginPasswordConfirm");

  const handleNewPasswordChallengeSubmit = async (formData) => {
    if (challengeUser) {
      const res = await handleNewPasswordChallenge({
        ...formData,
        challengeUserAttributes: challengeUser?.challengeUserAttributes,
        cognitoUser: challengeUser?.cognitoUser,
      });
      if (res.responseCode === 200) {
        navigate("/signin");
      } else {
        setShowModal(true);
      }
    }
  };

  const id = useId();

  return (
    <>
      <FormProvider {...methods}>
        <Card
          {...props}
          id={id}
          className="card--new-password-challenge"
          title="Welcome"
          description="Please enter a new password to activate your REMI account. Passwords must be at least 10 characters long and contain a number, a symbol, and a capital letter."
          collapsible={false}
          openByDefault={true}
        >
          <div className="card__content">
            <form
              className="card__new-password-challenge-form"
              onSubmit={methods.handleSubmit(handleNewPasswordChallengeSubmit)}
            >
              <PasswordInput
                name="loginPassword"
                label="New Password"
                showForgotPassword={false}
                shouldValidatePassword={true}
              />
              <PasswordInput
                name="loginPasswordConfirm"
                label="Confirm New Password"
                showForgotPassword={false}
                shouldValidatePassword={true}
                matchPassword={loginPasswordValue}
              />
              <Button
                size="medium"
                disabled={!loginPasswordValue || !loginPasswordConfirmValue}
                className="card__new-password-challenge-submit-button"
              >
                Submit
              </Button>
            </form>
          </div>
        </Card>
      </FormProvider>
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        heading="Password Reset Unsuccessful"
        subtitle="Please try again or contact your administrator."
      />
    </>
  );
};

export default NewPasswordChallengeCard;
